import { getTeamById } from '../../../actions/teams';
import { store } from '../../../index';

export function* onCancelInvite() {
  const { dispatch } = store;

  dispatch(getTeamById({}));

  yield true;
}
